/**
 * SPDX-FileCopyrightText: (c) 2024 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export const TEXT_EMBEDDING_PROVIDER_TYPES = {
	HUGGING_FACE_INFERENCE_API: 'huggingFaceInferenceAPI',
	HUGGING_FACE_INFERENCE_ENDPOINT: 'huggingFaceInferenceEndpoint',
	OPENAI: 'openai',
	TXTAI: 'txtai',
	VERTEX_AI: 'vertexAI',
};
